import React, { FC } from 'react';
import { LangE } from '../../models/enums';
import { useAppSelector } from '../../store/hooks';
import { selectCurrentLang } from '../../store/selectors/appSelectors';
import { Span } from '../../components/Text/Text';
import { isMobileOrTablet } from '../../utils/helpers/mediaQueries';
import isNoneValue from '../../utils/helpers/isNoneValue';
import { NO_VALUE_AD_AGENCY_LABEL, NO_VALUE_AD_AGENCY_LABEL_EN, NO_VALUE_AD_AGENCY_LABEL_HE } from '../../utils/constants';

type AdAgencyNamePropTypes = {
    campaign: any;
};

const AdAgencyName: FC<AdAgencyNamePropTypes> = (props) => {
    const { campaign } = props;
    const lang = useAppSelector(selectCurrentLang);

    const createdByAdAgencyName = campaign?.AdvertisingAgencyName;
    const createdForAdAgencyName = isNoneValue(campaign?.CreatedForAdvertisingAgencyName) ? '' : (campaign?.CreatedForAdvertisingAgencyName &&
        (createdByAdAgencyName !== campaign?.CreatedForAdvertisingAgencyName)) ?
        campaign?.CreatedForAdvertisingAgencyName : '';
    const createdForAdAgencyWithCorrectNoValue = createdForAdAgencyName.replace(NO_VALUE_AD_AGENCY_LABEL, lang === LangE.EN
        ? NO_VALUE_AD_AGENCY_LABEL_EN
        : NO_VALUE_AD_AGENCY_LABEL_HE
    );

    return (
        <>
            <span><Span>Ad Agency</Span>:&nbsp;{!!createdForAdAgencyName && !isMobileOrTablet() ? (
                <>
                    <br />
                    <span><Span>Created for</Span>:&nbsp;</span>
                </>
            ) : ''}</span>
            <span>{createdByAdAgencyName} {!!createdForAdAgencyName && (!isMobileOrTablet() ? (
                <>
                    <br />{createdForAdAgencyWithCorrectNoValue}
                </>
            ) : (
                <>
                    ({createdForAdAgencyWithCorrectNoValue})
                </>
            ))}
            </span>
        </>
    );
};

export default AdAgencyName;